import React, { useState, useEffect } from "react";
import { ResponsiveBar } from "@nivo/bar";
import { ResponsivePie } from "@nivo/pie";
import axios from "axios";
import { API_BASE } from "../config";

export default function EnergyClubPendingDashboard() {
  const [barData, setBarData] = useState([]);
  const [pieData, setPieData] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [activities, setActivities] = useState([]);

  const [selectedDistrict, setSelectedDistrict] = useState("0");
  const [selectedActivity, setSelectedActivity] = useState("0");

  // FY Logic
  const getCurrentFY = () => {
    const today = new Date();
    const y = today.getFullYear();
    const m = today.getMonth() + 1;
    return m < 4 ? `${y - 1}-${y}` : `${y}-${y + 1}`;
  };
  const currentFY = getCurrentFY();
  const [selectedFY, setSelectedFY] = useState(currentFY);

  const getFYList = () => {
    const [s, e] = currentFY.split("-").map(Number);
    return [`${s - 1}-${e - 1}`, `${s}-${e}`, `${s + 1}-${e + 1}`];
  };

  const financialYears = getFYList();


  const barChartSettings = {
    keys: ["count"],
    indexBy: "name",
    margin: { top: 80, right: 50, bottom: 160, left: 70 }, // increased
    padding: 0.35,
    colors: (bar) => ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"][bar.index % 4],
    borderColor: { from: "color", modifiers: [["darker", 1.2]] },
  
    axisBottom: {
      tickRotation: -35,
      tickSize: 5,
      tickPadding: 15, // increased
      legend: "District Names",
      legendPosition: "middle",
      legendOffset: 100, // moved further down
    },
  
    axisLeft: {
      legend: "Activity Not Submitted EnergyClubs",
      legendPosition: "middle",
      legendOffset: -50,
    },
  
    borderRadius: 6,
    labelSkipWidth: 12,
    labelSkipHeight: 12,
    labelTextColor: "#000",
  
    legends: [
      {
        dataFrom: "keys",
        anchor: "bottom",
        direction: "row",
        translateY: 80,
        itemsSpacing: 12,
        itemWidth: 140,
        itemHeight: 20,
        symbolSize: 18,
      },
    ],
  };
  

  const pieChartSettings = {
    margin: { top: 40, right: 20, bottom: 40, left: 20 }, // NEW
    innerRadius: 0.5,
    padAngle: 0.7,
    cornerRadius: 4,
    activeOuterRadiusOffset: 6,
    colors: { scheme: "pastel1" },
  };

  // Applied filters for heading
  const [appliedDistrict, setAppliedDistrict] = useState("0");
  const [appliedActivity, setAppliedActivity] = useState("0");
  const [appliedFY, setAppliedFY] = useState(currentFY);

  const getFYDates = (fy) => {
    const [start, end] = fy.split("-");
    return {
      fy_start: `${start}-04-01`,
      fy_end: `${end}-03-31`,
    };
  };

  useEffect(() => {
    axios.get(`${API_BASE}/districts`).then((res) => setDistricts(res.data));
    axios.get(`${API_BASE}/activities`).then((res) => setActivities(res.data));
  }, []);

  // Fetch PENDING COUNT
  const fetchNotSubmitted = async (
    dist = appliedDistrict,
    activity = appliedActivity,
    fy = appliedFY
  ) => {
    try {
      const { fy_start, fy_end } = getFYDates(fy);

      const res = await axios.get(`${API_BASE}/energy-club-pending`, {
        params: { dist, activity, fy_start, fy_end },
      });

      const bar = res.data.map((row) => ({
        name: row.district_name,
        district_id: row.dist_id,
        count: Number(row.not_submitted_count),
      }));

      const pie = res.data.map((row) => ({
        id: row.dist_id,
        label: row.district_name,
        value: Number(row.not_submitted_count),
        district_id: row.dist_id,
      }));

      setBarData(bar);
      setPieData(pie);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    fetchNotSubmitted();
  }, []);

  // Dynamic heading text
  const appliedDistrictName =
    appliedDistrict === "0"
      ? "All"
      : districts.find((d) => d.dist_id == appliedDistrict)?.district || "All";

  const appliedActivityName =
    appliedActivity === "0"
      ? "All"
      : activities.find((a) => a.activities_id == appliedActivity)?.activity ||
        "All";

//   const heading = (title) =>
//     `${title} (District: ${appliedDistrictName} | Activity: ${appliedActivityName} | FY: ${appliedFY})`;

    const heading = (title) => (
        <span>
          {title} (
            District: <span style={{ color: "red", fontWeight: "600" }}>{appliedDistrictName}
          </span>{" "}
          |{" "}
          
            Activity: <span style={{ color: "red", fontWeight: "600" }}>{appliedActivityName}
          </span>{" "}
          |{" "}
          
            FY: <span style={{ color: "red", fontWeight: "600" }}>{appliedFY}
          </span>
          )
        </span>
      );

  return (
    <div style={{ padding: 30, background: "#f4f6f8", minHeight: "100vh" }}>
      <h2 style={{  textAlign: "left",marginTop: "0" }}>Activity Not Submission Status</h2>

      {/* Filters */}
      <div style={{ display: "flex", gap: 20, flexWrap: "wrap", marginBottom: 20 }}>
        <label>
          District:
          <select
            value={selectedDistrict}
            onChange={(e) => setSelectedDistrict(e.target.value)}
            style={{ marginLeft: 10, padding: 5 }}
          >
            <option value="0">All</option>
            {districts.map((d) => (
              <option key={d.dist_id} value={d.dist_id}>
                {d.district}
              </option>
            ))}
          </select>
        </label>

        <label>
          Activity:
          <select
            value={selectedActivity}
            onChange={(e) => setSelectedActivity(e.target.value)}
            style={{ marginLeft: 10, padding: 5 }}
          >
            <option value="0">All</option>
            {activities.map((a) => (
              <option key={a.activities_id} value={a.activities_id}>
                {a.activity}
              </option>
            ))}
          </select>
        </label>

        <label>
          Financial Year:
          <select
            value={selectedFY}
            onChange={(e) => setSelectedFY(e.target.value)}
            style={{ marginLeft: 10, padding: 5 }}
          >
            {financialYears.map((fy) => (
              <option key={fy} value={fy}>
                {fy}
              </option>
            ))}
          </select>
        </label>

        <button
          onClick={() => {
            setAppliedDistrict(selectedDistrict);
            setAppliedActivity(selectedActivity);
            setAppliedFY(selectedFY);

            fetchNotSubmitted(selectedDistrict, selectedActivity, selectedFY);
          }}
          style={{
            padding: "10px 25px",
            background: "#d32f2f",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
          }}
        >
          Search
        </button>
      </div>

      {/* Bar Chart */}
      <div style={{ height: 450, background: "#fff", padding: 20, marginBottom: 30 }}>
        <h3>{heading("Bar Chart: Not Submitted Count")}</h3>

        <ResponsiveBar
          data={barData}
          {...barChartSettings}

          tooltip={({ data }) => (
            <div
              style={{
                padding: "6px 10px",
                background: "#fff",
                borderRadius: "6px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              }}
            >
              <strong>{data.name}</strong>: {data.count}
            </div>
          )}
        
          isInteractive={true}
          onMouseEnter={() => (document.body.style.cursor = "pointer")}
          onMouseLeave={() => (document.body.style.cursor = "default")}
        
          keys={["count"]}
          indexBy="name"
          colors={(bar) => ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0"][bar.index % 4]}
        
          onClick={(bar) => {
            sessionStorage.setItem("viewSchoolsFilters", JSON.stringify({
              district: bar.data.district_id,
              fy: appliedFY,
              activity: appliedActivity,
              status: "not_submitted",
            }));
          
            window.open("/view-schools", "_blank");
          }}
        />
      </div>

     {/* Pie Chart */}
<div style={{ height: 450, background: "#fff", padding: 20 }}>
  <h3>{heading("Pie Chart: Not Submitted Count")}</h3>

  <ResponsivePie
    data={pieData}
    {...pieChartSettings}   // ✅ FIX: use proper pie settings (NOT bar settings)

    theme={{
      background: "transparent",
      labels: { text: { cursor: "pointer" } },
      tooltip: { 
        container: { 
          background: "#fff",
          padding: "8px 12px",
          borderRadius: "6px",
          color: "#000",
          fontSize: "14px"
        }
      }
    }}

    isInteractive={true}

    // ⭐ Cursor pointer
    onMouseEnter={() => { document.body.style.cursor = "pointer"; }}
    onMouseLeave={() => { document.body.style.cursor = "default"; }}

    // ⭐ FIX TOOLTIP → "District Name : Count"
    tooltip={({ datum }) => (
      <div
        style={{
          padding: "6px 10px",
          background: "#fff",
          borderRadius: "6px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
        }}
      >
        <strong>{datum.label}</strong> : {datum.value}
      </div>
    )}

    arcLinkLabel={(d) => d.label}

    // onClick={(slice) =>
    //   window.open(
    //     `/view-schools?district=${slice.data.district_id}&fy=${appliedFY}&activity=${appliedActivity}&status=not_submitted`,
    //     "_blank"
    //   )
    // }

     onClick={(slice) => {
            sessionStorage.setItem("viewSchoolsFilters", JSON.stringify({
              district: slice.data.district_id,
              fy: appliedFY,
              activity: appliedActivity,
              status: "not_submitted",
            }));
          
            window.open("/view-schools", "_blank");
          }}
  />
</div>

    </div>
  );
}
